/**
 * toolBarをログインLP用に変更
 */
export const setToolBarTypeLoginLp = {
  created() {
    this.$store.dispatch('toolbar/DISP_SETTING_BUTTON')
    this.$store.dispatch('toolbar/DISP_ACCOUNT_SETTING_BUTTON')
    this.$store.dispatch('toolbar/DISP_NOTIFICATION_BUTTON')
    this.$store.dispatch('toolbar/HIDE_IO_SELECT_BUTTON')
    this.$store.dispatch('toolbar/SET_ADV_SELECT_BUTTON', { visible: false })
  },
}
